export default __webpack_public_path__ + "static/media/stage-two.6e8243ab.svg";